module.exports = __webpack_public_path__ + "static/media/voucher-icon-restaurant.becb9aa4.svg";